import React, { Component } from 'react';
import './OverdueCustomer.scss';
import clsx from 'clsx';
import cardimage from '../../../assets/images/cardimage.svg';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import { CircularProgressbar, buildStyles,   CircularProgressbarWithChildren} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import OverdueCustomerListView from '../CustomersListView/OverdueCustomerListView/OverdueCustomerListView';
import {withRouter} from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import handset from '../../../assets/images/handset.svg';
import whitehandset from '../../../assets/images/whitehandset.svg';
import messageblack from '../../../assets/images/messageblack.svg';
import message from '../../../assets/images/message.svg';
import userdefault from '../../../assets/images/userdefault.svg';
import MessageForCustomer from '../../modals/MessageForCustomer/MessageForCustomer';
import {BaseUrl, headers, ImageBaseUrl} from "../../../Environment";
import { withNamespaces } from 'react-i18next';

import moment from 'moment';
import ImageZoomModal from '../../modals/ImageZoomModal';

class OverdueCustomerCardview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      whiteimage:"none",
      phoneimage:"",
      messageblack:"",
      message:"none",
      interest:"16%",
      openmodal: false,
      row: "",
    }
  }
  detailspage(loanid) {
    this.props.history.push({
      pathname: '/customers/customerinfo',
      state: { loanID: loanid,
        fromOverDue: true
       }
    })
  }
  CardOver = (index) => {
    document.getElementById('messageblack'+ index).style.display="none"
    document.getElementById('message'+ index).style.display=""

    document.getElementById('handset'+ index).style.display="none"
    document.getElementById('whitehandset'+ index).style.display=""  
  }
  CardOut = (index) => {
    document.getElementById('messageblack'+ index).style.display = ''
    document.getElementById('message'+ index).style.display = 'none'

    document.getElementById('handset'+ index).style.display=""
    document.getElementById('whitehandset'+ index).style.display="none" 
  }

  messagecustomer = (details, value) => {
    this.setState({
      openmodal: true,
      row: details
    })
  }
  closemodal=()=> {
    this.setState({
      openmodal: false
    })
  }
    render(){
      const { t } = this.props;

      const percentage = 66;
      let newData = this.props.overdueData.map(data => {
        let amount = 0;
        let totalAmount = 0;
        let percent = 0;
        if (data.loanCollections.length > 0) {
          data.loanCollections.map((collection, index) => {
            amount = Number(collection.collectionAmount)
            if (index === data.loanCollections.length - 1) {
              // && data.loanCollections.PenaltyApplied
              // if(PenaltyApplied){
              totalAmount += amount - Number(data.loanCollections.PenaltyApplied?data.loanCollections.PenaltyApplied:0)
              //  }
            }
            else {
              totalAmount = amount
            }
           
          })
          percent = totalAmount / (data.totalAmountToCollect) * 100
          data.totalAmount = Math.round(percent);
        }
        return data;
      })

        return(
            <div>
            {this.props.list !== "list" ?
            <div>
                <div className="Allcustomercardviewpage">
                <Grid container spacing={1} style={{margin:"0px",marginRight: "43px"}}>
                   {this.props.overdueData && newData.map((open, index) =>{
                return  <Grid item xs={3} key={index}> 
                    <div>

                    <Card className="CardDiv"  onMouseOver={(event) => this.CardOver(index)} onMouseOut={(event) => this.CardOut(index)}>

      <CardHeader
        avatar={
          <Avatar aria-label="recipe">
            <ImageZoomModal
              src={
                open.customer?.proofs?.[0]?.proofImagePath
                  ? ImageBaseUrl + open.customer.proofs[0].proofImagePath
                  : userdefault
              }
              alt={open.customer?.firstName?.charAt(0)?.toUpperCase() || "Profile"}
              size={open.customer?.proofs?.[0]?.proofImagePath ? 40 : 31}
              allowDownload={!!open.customer?.proofs?.[0]?.proofImagePath}
              fileName={`${open.customer?.firstName || "profile"}.jpg`}
            />
          </Avatar>
        }
        action={
          <div>
                            <div >
                            <img src={messageblack} alt="message" className="messageblack" id={"messageblack"+index} style={{display:''}}/>
                            <img src={message} alt="message" className="message" id={"message"+index} style={{display:'none'}} onClick={this.messagecustomer.bind(this, open)}/>
                            </div>
                          </div>
                        }
        title={
          <div className="NameDiv Fonts">{(open.customer.firstName+" "+open.customer.lastName)?.length > 15 ? (open.customer.firstName+" "+open.customer.lastName)?.slice(0, 15) + "..." : (open.customer.firstName+" "+open.customer.lastName)}</div>
        }
        subheader={
          <div style={{marginTop: -15}}>
                            {open.customer.cust_id ? <p style={{marginBottom: -15, padding: 0, fontWeight: "bold"}} className='subheadingnameDiv Fonts'>({open.customer.cust_id})</p> : null}
          <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
            <p className="subheadingnameDiv Fonts">{open.loanId}</p>
            <div style={{display: "flex", flexDirection: "row"}}>
              <img src={handset} alt="handset" id={"handset"+index} className="handset" style={{ width: "8px", marginRight: "5px", marginLeft: "5px", display:'' }} />
              <img src={whitehandset} alt="whitehandset" id={"whitehandset" +index} className="whitehandset" style={{ width: "8px", marginRight: "5px", marginLeft: "5px", display:'none' }} />
              <p className="subheadingnameDiv Fonts">{open.customer.phone}</p>
            </div>
          </div>  
          </div>       
        }
      />
      <CardContent  onClick={this.detailspage.bind(this, open.loanId)}>
      <CardHeader
         avatar={
          <div style={{borderRadius:'50%', backgroundColor:'transparent', width:'53px'}}>
          <CircularProgressbar value={open.totalAmount ? open.totalAmount : 0} text={`${open.totalAmount ? open.totalAmount : 0}%`} styles={buildStyles({  textColor: '#3E4664',  pathColor: '#00D95E',  trailColor: '#D2D2DC', textSize: '30px'})} />
          </div>
        } 
        title={
          <div style={{display:"flex"}}>
          <div className="MoneydetailsDiv Fonts">{open.loanAmount}</div>
          {open.rateOfInterest? <div className="MoneydetailsDiv Fonts">&nbsp; at &nbsp;{open.rateOfInterest || ""} %</div>:" "}
          </div>
          }
        subheader= {
          <div>
          <div className="subheaderDiv">
          <div className="subheaderStatus Fonts"  style={{backgroundColor:"#ffe5e5", color:"#FF0000"}}>{open.loanPaymentStatus}</div>
          <div className="subheaderDays Fonts">{open.method ==="EMI Method"?"EMI":"CMI"}</div>
          </div>
          <div style={{textTransform:"capitalize"}} className="loantypename Fonts">{open.loanType.loanType} | {open.user.firstName}</div>
          </div>
        }
      />
      </CardContent>
      <CardActions disableSpacing>
      <div style={{display:'flex', width: '100%', marginTop: '5px'}}>
        <div className="footerDiv1">
          <div  className="footerDivdate Fonts">{moment(open.nextDueDate? open.nextDueDate:open.startDate).format("DD MMM YYYY")}</div>
          <div  className="footerDivdatedetails Fonts">{t('Loans.Date')}</div>
        </div>
        <div  className="footerDiv2" style={{flexDirection: "column"}}>
        <div  className="footerDivmonth Fonts">{open.loanTenureType}</div>
          <div  className="footerDivmonthdetails Fonts">{t('Loans.Collseq')}</div>
        </div>
      </div>
        </CardActions>
       
     
    </Card>
    </div>
    
     </Grid>
                   })}
                  </Grid>
                  <MessageForCustomer open={this.state.openmodal} close={this.closemodal} rowData={this.state.row} />
    </div>
    
    </div>
    :
            <OverdueCustomerListView/>
            }; 
            </div>         
        )
    }
}
export default withNamespaces()(withRouter(OverdueCustomerCardview));